import { withApollo } from 'react-apollo';
import { AccessibilityWrapper, notify } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { videoMarkComplete } from 'legacy-src/queries';
import { toast } from 'chameleon/ui-stack/ui/toast';
import React from 'react';

const VideoMarkCompleteAction = ({
  assignmentId,
  onUpdate,
  client,
  disabled,
}) => {
  const markCompleteClicked = async (e) => {
    e.stopPropagation();
    const response = await client.mutate({
      mutation: videoMarkComplete,
      variables: {
        id: +assignmentId,
      },
    });

    const { ok } = response.data.markCompleteEmbedVideo;

    if (ok) {
      toast('Successfully marked complete', { timeout: 5 });
      onUpdate();
    } else {
      notify.error(`Please, contact the support team.`, { timeout: 5 });
    }
  };

  return (
    <AccessibilityWrapper>
      <SingleAction
        onClick={markCompleteClicked}
        tabIndex={0}
        aria-label="Mark Complete"
        iconName="mark_complete"
        iconSize="1.8rem"
        title="Mark Complete"
        disabled={disabled}
      >
        <span className="item-text">Mark Complete</span>
      </SingleAction>
    </AccessibilityWrapper>
  );
};

export default withApollo(VideoMarkCompleteAction);
